<template lang="html">
  <div v-if="active" class="flash-message">
    <div
      :class="classList"
      role="alert">
      <strong>{{ title }}</strong> {{ content }}
      <button
        @click="$emit('close')"
        v-if="closable"
        type="button"
        class="close">
        <font-awesome-icon :icon="[ 'fas', 'times' ]" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    title: String,
    content: String,
    closable: Boolean,
    active: Boolean
  },

  computed: {
    classList () {
      return {
        'alert': true,
        'alert-dismissible': this.closable,
        'fade': true,
        'show': this.active,
        [this.type || 'alert-danger']: true
      }
    }
  }
}
</script>

<style lang="scss">
  .flash-message {
    margin: 0.5rem 0;
    // width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/FlashMessage.vue